"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _antd = require("antd");
require("./help.less");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
class Help extends _react.default.Component {
  render() {
    const {
      text
    } = this.props;
    return /*#__PURE__*/_react.default.createElement(_antd.Tooltip, {
      className: "help-tooltip",
      title: text,
      color: "geekblue"
    }, /*#__PURE__*/_react.default.createElement("a", {
      href: "#help"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "help-icon"
    }, "?")));
  }
}
exports.default = Help;
//# sourceMappingURL=help.js.map